import request from './request'

export function getReminderDefinitionPage(params) {
  return request.get('/reminders', { params })
}

export function getReminderDefinitionDetail(id) {
  return request.get(`/reminders/${id}`)
}

export function createReminderDefinition(data) {
  return request.post('/reminders', data)
}

export function updateReminderDefinition(id, data) {
  return request.put(`/reminders/${id}`, data)
}

export function enableReminderDefinition(id) {
  return request.put(`/reminders/${id}/enable`)
}

export function disableReminderDefinition(id) {
  return request.put(`/reminders/${id}/disable`)
}

export function deleteReminderDefinition(id) {
  return request.delete(`/reminders/${id}`)
}

export function getMyReminderTaskPage(params) {
  return request.get('/reminder-tasks/my', { params })
}

export function closeReminderTask(id) {
  return request.put(`/reminder-tasks/${id}/close`)
}

export function continueReminderTask(id) {
  return request.put(`/reminder-tasks/${id}/continue`)
}

export function completeReminderTask(id) {
  return request.put(`/reminder-tasks/${id}/complete`)
}

export function convertReminderTaskToTodo(id, data) {
  return request.put(`/reminder-tasks/${id}/todo`, data)
}

export function postponeReminderTask(id, data) {
  return request.put(`/reminder-tasks/${id}/postpone`, data)
}
